import React from 'react'
import { AiOutlineSearch } from "react-icons/ai";
export const SearchBar = ({
    searchByBtn,
    setSearchByBtn,
    handleSearch,
    searchByButton
}) => {
    return (
        <div className='col-sm-8 col-md-8 col-lg-8 col-xl-9'>
            <div className="input-group flex-nowrap ">
                <input type="search" className="form-control" placeholder="Search" aria-label="Username" aria-describedby="addon-wrapping"
                    value={searchByBtn}
                    onChange={(e) => setSearchByBtn(e.target.value)}
                    onKeyPress={handleSearch} />
                <span style={{ cursor: `pointer` }} className="input-group-text"

                    onClick={() => searchByButton()}
                    disabled={searchByBtn?.length > 0 ? false : true}
                    id="addon-wrapping"><AiOutlineSearch /> Search</span>
            </div>
        </div>
    )
}
